import { __ } from '@wordpress/i18n';
const { RichText, InnerBlocks } = wp.blockEditor;

export default ({ attributes, setAttributes, className }) => {
    const handleOnChangeSubTitle = ( subtitle ) => {
        setAttributes({ subtitle });
    };

    return(
        <div className={ className }>
            <div className="wrapper">
                <InnerBlocks 
                template={[ ['core/heading'], ['core/paragraph'], ['core/button'] ]}
                templateLock="all"
                />

                <RichText
                tagName="p"
                className="Subtitle"
                placeholder={__("Subtítulo da seção")}
                value={attributes.subtitle}
                onChange={handleOnChangeSubTitle}
                />
            </div>
        </div>
    );
}